import classNames from "classnames";
import styles from "./MobileContentRelatedInformation.module.scss";
import { useTableOfContentsItems } from "../../hooks/tableOfContentsHooks/useTableOfContentsItems";
import { useActiveTocItem } from "../../hooks/tableOfContentsHooks/useActiveTocItem";
import { selectC5State } from "../counter/counterSlice";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { expertGroupContent, updateContent } from "./ContentSideBarSlice";

const MobileContentRelatedInformation = ({ expandExpertGroupsSideBar, expandUpdatesSideBar, msPath, popupClose }) => {
  useTableOfContentsItems(msPath);
  useActiveTocItem();
  const currentC5State = useSelector(selectC5State);
  const showExpertGroupContent = useSelector(expertGroupContent);
  const updateContentToShow = useSelector(updateContent);

  return (
    <div className={styles.popup}>
      <div className={styles.headingRow}>
        <button className={styles.popupClose} onClick={popupClose}>
          <i className="size-25 medium tg-icons-Cross"></i>
        </button>
        <div className={classNames("size-16 semibold", styles.heading)}>
          Related information
        </div>
        <div className={styles.spacer}></div>
      </div>
      {showExpertGroupContent && (
        <div className={classNames("size-14 medium", styles.linkRow)}>
          <button
            type="button"
            className={styles.openInfoButton}
            onClick={expandExpertGroupsSideBar}
          >
            <div>Expert contributors</div>
            <i className="tg-icons-LeftArrow medium size-16"></i>
          </button>
        </div>
      )}
      {updateContentToShow && (
        <div className={classNames("size-14 medium", styles.linkRow)}>
          <button
            type="button"
            className={styles.openInfoButton}
            onClick={expandUpdatesSideBar}
          >
            <div>Topic updates</div>
            <i className="tg-icons-LeftArrow medium size-16"></i>
          </button>
        </div>
      )}
      <div className={classNames("size-14 medium", styles.publishDate)}>
        {currentC5State.itemPubDate}
      </div>
    </div>
  );
};

MobileContentRelatedInformation.propTypes = {
  expandExpertGroupsSideBar: PropTypes.func.isRequired,
  expandUpdatesSideBar: PropTypes.func.isRequired,
  msPath: PropTypes.string.isRequired,
  popupClose: PropTypes.func.isRequired,
};

export default MobileContentRelatedInformation;